module.exports = __webpack_public_path__ + "static/media/A1.3704c27b.jpg";